import defaultConfig from "./config";
import GetFtr from "./GetFtr";

class GetFtrUpdates extends GetFtr {

    #endpoint = '/action/getFtrUpdate';

    constructor(selector, config = defaultConfig) {
        super(config);
        this.buttons = super._curateButtons(selector);
        this.batchSize = config.batchSize.updates;
    }

    async initialize() {
        const dois = Object.keys(this.buttons);
        for (let i = 0; i < dois.length; i += this.batchSize) {
            this._fetchRequest(this.#endpoint, dois.slice(i, i + this.batchSize), 'low').then(response => {
                response.documents.forEach(doc => {
                    const {updates} = doc;
                    if (!updates || updates.length === 0) return;

                    let bestRetraction, bestUpdate;

                    updates.forEach(update => {
                        const type = update.updateType;
                        if (type === 'retraction') {
                            bestRetraction = this.#getBestUpdate(bestRetraction, update);
                        } else {
                            bestUpdate = this.#getBestUpdate(bestUpdate, update);
                        }
                    });

                    bestUpdate = bestRetraction || bestUpdate;

                    const disclaimerText = bestRetraction ?
                        `This document was retracted ${bestRetraction.updateDate && ' at ' + bestRetraction.updateDate}.`
                        : 'This document has been updated.';

                    const reasonsHtml = bestUpdate.reasons?.length > 0 ?
                        `<div class="reasons">
                                <div class="reasons-header">Reasons:</div>
                                <ul class="reasons-list">
                                    ${bestUpdate.reasons?.map(reason => `<li>${reason}</li>`).join('')}
                                </ul>
                            </div>` : '';

                    const updateButtonHtml = `
                          <div class="get-ftr-update ${bestRetraction ? 'retraction' : 'update'}">
                            <a href="https://document-status.getft.io/doi/${doc.doi}"><i aria-hidden="true" class="icon icon-warning-triangle"></i>${bestRetraction ? 'Retraction' : 'Updates'}</a>
                          </div>
                        `;

                    const button = this.buttons[doc.doi];
                    button.insertAdjacentHTML('afterend', updateButtonHtml);
                    const updateButton = button.nextElementSibling;
                    const tooltipHtml = `
                            <div class="get-ftr-tooltip ${bestRetraction ? 'retraction' : 'update'}">
                              <i aria-hidden="true" class="icon icon-warning-triangle"></i>
                              <div>${disclaimerText}</div>
                              ${reasonsHtml}
                              <div>Click for further information.</div>
                            </div>`
                    const template = document.createElement('template');
                    template.innerHTML = tooltipHtml.trim();
                    const tooltipNode = template.content.firstElementChild;
                    document.body.appendChild(tooltipNode);
                    this.constructor.initializeTooltip(updateButton.children[0], tooltipNode);
                });
            });
        }
    }

    #getBestUpdate(a, b) {
        if (!a) return b;
        if (!b) return a;

        const dateA = new Date(a.updateDate);
        const dateB = new Date(b.updateDate);

        if (dateB > dateA) return b;
        if (dateA > dateB) return a;

        const reasonsA = a.reasons?.length || 0;
        const reasonsB = b.reasons?.length || 0;

        return reasonsB > reasonsA ? b : a;
    }
}

export default GetFtrUpdates;
